var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(!_vm.$store.getters.login.login ? 'background: #225856;' : ''),attrs:{"id":"oraciones"}},[_c('msg-component'),(_vm.$store.getters.login.login)?_c('nav-drawer'):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),(_vm.$store.getters.login.login)?_c('bottom-menu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }